import LocalStorageService from "@/services/LocalStorageService";

const localStorageService = LocalStorageService.getService();

export class Localstorage {
    constructor() {
        this.localStorage = localStorageService;
    }
}